<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p34" title="34">
<figure class="fullpage">
<img alt="" src="image/p034.jpg"/>
<figcaption>
<p class="caption"><a href="#/html/p035">Spinach-Pesto Egg Bakes</a></p>
</figcaption>
</figure>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p034.vue?297a375e